import type { FormFieldsReference } from './FormEditor.types';

export function getAllFormFields(
    $Resources: any,
    customFields:
        | {
              [key: string]: string;
          }
        | undefined
) {
    if (!$Resources) return [];

    const fields = <FormFieldsReference>[
        {
            contactField: 'Email',
            type: 'email',
            label: $Resources.ContactEmailLabel,
            description: '',
            required: true,
            placeholder: '',
        },
        {
            contactField: 'Name',
            type: 'text',
            label: $Resources.ContactNameLabel,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'FirstName',
            type: 'text',
            label: $Resources.ContactFirstNameLabel,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'LastName',
            type: 'text',
            label: $Resources.ContactLastNameLabel,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'SmsNumber',
            type: 'tel',
            label: $Resources.ContactSmsNumberLabel,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'JobTitle',
            type: 'text',
            label: $Resources.ContactModalJobTitle,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Salutation',
            type: 'text',
            label: $Resources.ContactModalSalutation,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'StreetAddress',
            type: 'text',
            label: $Resources.ContactModalStreetAddress,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'City',
            type: 'text',
            label: $Resources.ContactModalCity,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'PostalCode',
            type: 'text',
            label: $Resources.ContactModalPostalCode,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'State',
            type: 'text',
            label: $Resources.ContactModalState,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Country',
            type: 'text',
            label: $Resources.ContactModalCountry,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Region',
            type: 'text',
            label: $Resources.ContactModalRegion,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Gender',
            type: 'text',
            label: $Resources.ContactModalGender,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Birthday',
            type: 'text',
            label: $Resources.ContactModalBirthday,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'CompanyName',
            type: 'text',
            label: $Resources.ContactModalCompanyName,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Industry',
            type: 'text',
            label: $Resources.ContactModalIndustry,
            description: '',
            required: false,
            placeholder: '',
        },
        {
            contactField: 'Website',
            type: 'text',
            label: $Resources.ContactModalWebsite,
            description: '',
            required: false,
            placeholder: '',
        },
    ];

    if (customFields) {
        for (let i = 1; i !== 11; i++) {
            fields.push({
                contactField: 'Custom' + i,
                type: 'text',
                label: customFields['CustomField' + i],
                description: '',
                required: false,
                placeholder: '',
            });
        }

        for (let i = 1; i !== 3; i++) {
            fields.push({
                contactField: 'CustomLong' + i,
                type: 'text',
                label: customFields['CustomLong' + i],
                description: '',
                required: false,
                placeholder: '',
            });
        }

        for (let i = 1; i !== 7; i++) {
            fields.push({
                contactField: 'CustomDate' + i,
                type: 'date',
                label: customFields['CustomDate' + i],
                description: '',
                required: false,
                placeholder: '',
            });
        }

        for (let i = 1; i !== 7; i++) {
            fields.push({
                contactField: 'CustomNumeric' + i,
                type: 'number',
                label: customFields['CustomNumeric' + i],
                description: '',
                required: false,
                placeholder: '',
            });
        }

        for (let i = 1; i !== 7; i++) {
            fields.push({
                contactField: 'CustomBool' + i,
                type: 'boolean',
                label: customFields['CustomBool' + i],
                description: '',
                required: false,
                placeholder: '',
                options: [
                    { label: $Resources.BooleanYesLabel, value: 'true' },
                    { label: $Resources.BooleanNoLabel, value: 'false' },
                ],
            });
        }
    }

    return fields;
}
